import { render, staticRenderFns } from "./AppointmentStatuses.vue?vue&type=template&id=7e93b454&"
import script from "./AppointmentStatuses.vue?vue&type=script&lang=ts&"
export * from "./AppointmentStatuses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports